import * as React from 'react';

import {GoogleLogoIcon} from 'shells/logos/google-g';
import {Office365LogoIcon} from 'shells/logos/office-365';
import {ConnectionInfoTitle} from 'shells/status-button/connection-info-title';

import type {CalendarSync} from 'nutshell-graphql-types';

type Props = {
    status: CalendarSync;
};

export function ConnectedCalendarInfoTitle(props: Props) {
    const {calendars} = props.status;
    const selectedCalendar = calendars.find((cal) => cal.isSelected || cal.syncType === 'PRIMARY');
    const selectedCalendarName = selectedCalendar ? selectedCalendar.name : 'No calendar selected';

    const icon =
        props.status && props.status.externalService === 'OFFICE365' ? (
            <Office365LogoIcon size={11} alignCenter={true} />
        ) : (
            <GoogleLogoIcon size={11} alignCenter={true} />
        );

    return <ConnectionInfoTitle icon={icon} primaryText={selectedCalendarName} />;
}
